import React from "react";

// Skeleton Components
const SkeletonInput = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "40px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const SkeletonDocumentUpload = ({ labelWidth = "150px" }) => (
  <div className="skeleton-document-upload">
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-upload-area"
      style={{
        width: "100%",
        height: "120px",
        background: "#f0f0f0",
        borderRadius: "8px",
      }}
    ></div>
  </div>
);

const AddRegulatoryCompliancesSkelton = () => {
  return (
    <div className="form-skeleton">
      {/* Vehicle Selection Skeleton */}
      <div className="row mb-4">
        <div className="col-12 col-md-6 mb-4">
          <SkeletonInput labelWidth="120px" />
        </div>
        <div className="col-12 col-md-6 mb-4">
          <SkeletonDocumentUpload labelWidth="160px" />
        </div>
      </div>

      {/* Document Upload Skeletons */}
      <div className="row mb-4">
        <div className="col-12 col-md-6 mb-4">
          <SkeletonDocumentUpload labelWidth="140px" />
        </div>
        <div className="col-12 col-md-6 mb-4">
          <SkeletonDocumentUpload labelWidth="140px" />
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-12 col-md-6 mb-4">
          <SkeletonDocumentUpload labelWidth="140px" />
        </div>
        <div className="col-12 col-md-6 mb-4">
          <SkeletonDocumentUpload labelWidth="160px" />
        </div>
      </div>

      {/* Button Skeletons */}
      <div className="pt-4 mt-3 border-top text-end">
        <div
          className="skeleton-button d-inline-block me-3"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
        <div
          className="skeleton-button d-inline-block"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default AddRegulatoryCompliancesSkelton;
